export default __webpack_public_path__ + "3b102bc71cff1582f04f8a5a1f9c959b.svg";